export default "__VITE_ASSET__DhJHqR5g__";